import { NbToastrService } from '@nebular/theme';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';
import { UserService } from '../../apiclient';
import { UserSessionService } from '../../UserSession/user-session.service';
import {Md5} from 'ts-md5/dist/md5';
/**
 * Componente que renderiza el editor de usuarios
 */
@Component({
  selector: 'ngx-user-editor',
  templateUrl: './user-editor.component.html',
  styleUrls: ['./user-editor.component.scss']
})
export class UserEditorComponent implements OnInit {

  userdata: any = {};
  idcompany: string;
  idusuario: string;
  loading: boolean = false;
  rolesdeusuario =['manager','reporter'];
   md5 = new Md5();
  constructor(private route: ActivatedRoute, private userService: UserService,
    private userSessionService: UserSessionService,
    private nbToastrService: NbToastrService,
    private location: Location) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.idcompany = params.get('company');
      this.idusuario = params.get('usuario');

      if(this.idusuario != '0'){
      this.userService.singleuserfromcompany(+this.idcompany,+this.idusuario,this.userSessionService.accessToken).subscribe((data) => {
        this.userdata = data;
      });
    }
    })
  }


  /**
   * Regresa a la página anterior
   */
  back(): void{
    this.location.back()
  }

  /**
   * Guarda el usuario en edición
   */
  guardar(): void{
    this.loading = true;


    if(typeof this.userdata.password == 'undefined' || this.userdata.password == null || this.userdata.password == ''){
      delete this.userdata.password;
    }else{
      this.userdata.password = this.md5.appendStr(this.userdata.password).end();
    }
    if(this.userdata.account_disabled == null){
      this.userdata.account_disabled = false;
    }
    if(typeof this.userdata.phone == 'undefined' || this.userdata.phone == null){
      this.userdata.phone='';
    }
    if(typeof this.userdata.surname == 'undefined' || this.userdata.surname == null){
      this.userdata.surname='';
    }

    if(this.idusuario == '0'){
      this.userService.createuserfromcompany(+this.idcompany,this.userdata,this.userSessionService.accessToken).subscribe((data) => {
        this.nbToastrService.success('Guardado con éxito','Guardar')
        this.userdata = data;
        this.loading = false;
      });
    }else{
      this.userService.updateuser(+this.idcompany,+this.idusuario,this.userdata,this.userSessionService.accessToken).subscribe((data) => {
        this.nbToastrService.success('Guardado con éxito','Guardar')
        this.userdata = data;
        this.loading = false;
      })
    }

  }
}
